import { AuthMethodEnum } from "../constants/authMethod";

export const mockAuthMethod = [
  {
    name: AuthMethodEnum.CREDENTIALS,
    value: "Authentication using Email and Password combination",
  },
  {
    name: AuthMethodEnum.AUTH_CODE,
    value: "Authentication using Multi Factor - Email Codes",
  },
];
